// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['fr_BE']  = {
  "name": "fr_BE",
  "day": {
    "abbrev": [
      "dim",
      "lun",
      "mar",
      "mer",
      "jeu",
      "ven",
      "sam"
    ],
    "full": [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi"
    ]
  },
  "month": {
    "abbrev": [
      "jan",
      "fév",
      "mar",
      "avr",
      "mai",
      "jun",
      "jui",
      "aoû",
      "sep",
      "oct",
      "nov",
      "déc"
    ],
    "full": [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d/%m/%y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%A %-e %B %Y, %H:%M:%S (UTC%z)"
}

